import PromoReportContainer from './PromoReportContainer';

export default PromoReportContainer;
